import React from "react"
import { ArrowLeftFromLine, ArrowRightFromLine, X, Lock, LockOpen, Play, Trash2, SquareChartGantt } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"


export default function PresetTitlebar(){

  const { store, AppStore }:any = appStore() 
  const { update } = AppStore
  
  return (
    <div className=" bg-slate-900 w-full h-8 px-2 flex justify-between items-center rounded-tl">
      <span className="text-xs uppercase tracking-wide">testing</span>
      <SquareChartGantt className="w-4 h-4 cursor-pointer stroke-2" onClick={() => update("preview.reports", !store.preview.reports)} />
    </div>
  )
}